import React from 'react';

const BackgroundFixed: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  return (
    <div
      data-testid="background-fixed"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '80vh'
      }}
      onClick={onClick}
    ></div>
  );
};

export default BackgroundFixed;
